import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/var/www/laporanJP/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/laporanJP/layouts/default.vue").then(m => m.default || m))
}